// src/components/SubmissionSuccess.js
import React from 'react';
import Typography from '@mui/material/Typography';

const SubmissionSuccess = () => {
    return (
        <>
            <Typography variant="h4" component="h1" gutterBottom align="center">
                Anmeldung erhalten!
            </Typography>
            <Typography variant="h6" align="center" color="text.secondary">
                Wir prüfen deine Bewerbung und melden uns per E-Mail. Du wirst manuell freigeschaltet oder landest auf der Warteliste.
            </Typography>
        </>
    );
};

export default SubmissionSuccess;